import m from "../link/link.vue.js";
import _ from "../../tracking/tracking-mixin.vue.js";
import { resolveComponent as y, openBlock as n, createElementBlock as i, normalizeClass as a, createElementVNode as d, toDisplayString as c, renderSlot as h, createCommentVNode as r, createBlock as f, Fragment as k, renderList as z } from "vue";
/* empty css              */
import v from "../../_virtual/_plugin-vue_export-helper.js";
const C = {
  name: "DsLogoBar",
  components: {
    DsLink: m
  },
  mixins: [_],
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    link: {
      type: Object,
      default: null
    },
    lazy: {
      type: Boolean,
      default: !0
    },
    orientation: {
      type: String,
      default: "vertical",
      validator: (e) => ["vertical", "horizontal"].includes(e)
    },
    /**
     * Logo items, array of objects with image src and alt text
     */
    items: {
      type: Array,
      required: !0,
      validator: (e) => e.every((l) => typeof l == "object" && ["src", "name"].every((t) => t in l))
    },
    /**
     * Aligns logo items center on the horizontal axis
     */
    alignCenter: {
      type: Boolean,
      default: !1
    },
    /**
     * SPECIAL CASE - used in `/customers`, where the logobar is used as a Hero - center aligns in mobile and tablet
     */
    useAsHero: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    isHorizontalLayout() {
      return this.orientation === "horizontal";
    },
    computedItemsWidthClass() {
      var e, l;
      if (this.alignCenter && !this.isHorizontalLayout) {
        if ([7, 8].includes((e = this.items) == null ? void 0 : e.length))
          return "ds-logo-bar__items--width-small";
        if ([9, 10].includes((l = this.items) == null ? void 0 : l.length))
          return "ds-logo-bar__items--width-medium";
      }
      return null;
    }
  }
}, L = ["textContent"], w = ["textContent"], x = {
  key: 2,
  class: "ds-margin-top-12 ds-text"
}, H = {
  key: 0,
  class: "ds-lg-grid__col--1"
}, b = ["src", "alt", "loading"];
function B(e, l, t, j, D, o) {
  const g = y("DsLink");
  return n(), i("div", {
    class: a(["ds-logo-bar", { "ds-text-align-center": t.alignCenter, "ds-grid ds-align-items-center": o.isHorizontalLayout }])
  }, [
    d("div", {
      class: a({
        "ds-grid__col ds-grid__col--12 ds-lg-grid__col--5": o.isHorizontalLayout,
        "ds-grid__col ds-grid__col--12 ds-lg-grid__col--8 ds-lg-grid__col--offset-2": !o.isHorizontalLayout && t.alignCenter,
        "ds-logo-bar__hero": t.useAsHero
      })
    }, [
      t.title && t.useAsHero ? (n(), i("h1", {
        key: 0,
        class: "ds-heading-xlarge",
        "data-j-hero-title": "",
        textContent: c(t.title)
      }, null, 8, L)) : (n(), i("h2", {
        key: 1,
        class: "ds-heading",
        "data-j-title": "",
        textContent: c(t.title)
      }, null, 8, w)),
      e.$slots.description ? (n(), i("div", x, [
        h(e.$slots, "description")
      ])) : r("", !0),
      t.link ? (n(), f(g, {
        key: 3,
        "tracking-data": { "component-name": e.$options.name, text: t.link.title, title: t.title, ...e.trackingDataProvided },
        url: t.link.url,
        "lazy-url-endpoint": t.link.lazyUrlEndpoint,
        "open-in-new-window": t.link.openInNewWindow,
        nuxt: t.link.nuxt,
        content: t.link.title,
        "icon-right": { category: "arrows", name: "chevron-right-small" },
        class: "ds-margin-top-24"
      }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "content"])) : r("", !0)
    ], 2),
    o.isHorizontalLayout ? (n(), i("div", H)) : r("", !0),
    d("div", {
      class: a(["ds-logo-bar__items", [
        {
          "ds-justify-content-center": t.alignCenter,
          "ds-margin-top-48": t.title || !!e.$slots.description || t.link,
          "ds-grid__col ds-grid__col--12 ds-lg-grid__col--6 ds-lg-margin-top-0": o.isHorizontalLayout
        },
        o.computedItemsWidthClass
      ]]),
      "data-j-logo-bar": ""
    }, [
      (n(!0), i(k, null, z(t.items, (s, u) => (n(), i("img", {
        key: `item-${u}`,
        class: "ds-logo-bar__image",
        src: s.src,
        alt: s.name,
        loading: t.lazy ? "lazy" : "eager",
        "data-j-item": ""
      }, null, 8, b))), 128))
    ], 2)
  ], 2);
}
const W = /* @__PURE__ */ v(C, [["render", B]]);
export {
  W as default
};
